import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatPercentages, formatUSD } from '../../../../helpers/formats';
import useUserStatistics from '../../../../hooks/web3/vault/useUserStatistics';

const AverageApy: React.FC = () => {
    const { userStatistics } = useUserStatistics();

    const spoolApys = userStatistics
        ? Object.entries(userStatistics.spools).filter(
              ([_, { userUnderlying }]) => userUnderlying !== 0
          )
        : [];

    return (
        <Detail
            title={
                <>
                    <span>Your Average Spool APY</span>
                    <InfoPopUp>
                        <span>Your Average Spool APY:</span>
                        {spoolApys.length ? (
                            <>
                                <strong className='block'>
                                    $
                                    {formatUSD(
                                        userStatistics?.total?.userUnderlying || 0
                                    )}
                                </strong>
                                <strong className='block'>
                                    ~
                                    {formatPercentages(
                                        parseFloat(
                                            userStatistics?.total?.apy.toString() || '0'
                                        ) * 100 || 0
                                    )}
                                    % APY
                                </strong>
                                <span className='mt block'>Based on:</span>
                                {spoolApys.map(
                                    ([
                                        spoolId,
                                        { apy, userUnderlying, spoolDetails },
                                    ]) => (
                                        <div key={spoolId} className='mt'>
                                            <span>
                                                {spoolDetails?.spoolName || 'Spool'}
                                            </span>
                                            <strong className='block'>
                                                {formatUSD(userUnderlying || 0)}{' '}
                                                {spoolDetails?.underlying?.symbol ||
                                                    'Asset'}
                                            </strong>
                                            <strong className='block'>
                                                {formatPercentages(
                                                    parseFloat(apy.toString()) * 100 || 0
                                                )}
                                                % APY
                                            </strong>
                                        </div>
                                    )
                                )}
                            </>
                        ) : (
                            <strong className='block'>N/A</strong>
                        )}
                    </InfoPopUp>
                </>
            }
            value={`~${formatPercentages(
                parseFloat(userStatistics?.total?.apy.toString() || '0') * 100 || 0
            )}%`}
        />
    );
};

export default AverageApy;
